import React from "react";

import type { FieldProps as IFieldProps } from "react-final-form";
import { Field } from "react-final-form";

import type { OutlinedTextFieldProps as IMuiOutlinedTextFieldProps } from "@mui/material/TextField";
import MuiTextField from "@mui/material/TextField";

import mapFinalFormMetaToErrorProps from "./mapFinalFormMetaToErrorProps";

export interface ITextFieldProps<FormValueType> extends Omit<IMuiOutlinedTextFieldProps, "variant"> {
  FieldProps?: IFieldProps<FormValueType>;
  validate?: IFieldProps<FormValueType>["validate"];
  name: string;
  variant?: IMuiOutlinedTextFieldProps["variant"];
}

function TextField<FormValueType>(props: ITextFieldProps<FormValueType>) {
  const { name, validate, FieldProps: FieldPropsProp = {}, variant = "outlined", ...restProps } = props;

  const fieldProps = {
    ...FieldPropsProp,
    name,
    validate,
  };

  return (
    <Field<FormValueType> {...fieldProps}>
      {({ input, meta }) => {
        const { helperText, ...filteredProps } = restProps;

        const textFieldProps: IMuiOutlinedTextFieldProps = {
          ...mapFinalFormMetaToErrorProps(meta),
          name,
          variant,
          ...input,
          ...filteredProps,
        };

        if (!textFieldProps.helperText) {
          textFieldProps.helperText = helperText;
        }

        return <MuiTextField {...textFieldProps} />;
      }}
    </Field>
  );
}

export default TextField;
